<template>
	<div>
		<div v-if="!dialogVisible">
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">工资占比表</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">

					<el-row>
						<!-- 左侧组织架构 -->
						<!-- <el-col :span="4" style="background-color: #f7f8fa; height: 750px;">
                            <Structure ref="Structure" @parentFind="Find" :condition="condition"></Structure>
                        </el-col> -->

						<!-- 右侧列表 -->
						<el-col :span="24">
							<el-row style="padding-left: 46px; padding-top: 40px;">

								<el-col :span="5">
									<span>日期</span>
									<el-date-picker v-model="condition.years_date" type="month" placeholder="请选择"
										value-format="yyyy-MM" style="margin-left: 10px;">
									</el-date-picker>
								</el-col>
								<el-col :span="2">
									<el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Find">
										查询</el-button>
								</el-col>
								<el-col :span="2">
									<el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="openfileUrl()">导入</el-button>
								</el-col>
								<el-dialog title="导入" :visible.sync="dialogVisibledr" width="30%"
									@close='closeDialog' :before-close="handleClose">
									<el-upload class="upload-demo" ref="adModel"
										:action="$globals.http + '/file/upload'" multiple
										:file-list="fileList" :on-success="handleAvatarSuccess"
										:on-remove="handleRemove">
										<el-button
											style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
											选择文件</el-button>
									</el-upload>
									<div style="margin-top: 30px;">
										<div style="font-size: 18px;" v-if="fileDatatitle">导入失败项目名单：
										</div>
										<div
											style="display: flex; justify-content: flex-start;flex-wrap: wrap;">
											<div v-for="(item,index) in fileData"
												style="flex:1; width: calc((100% - 20px) / 5);min-width: calc((100% - 20px) / 5);max-width: calc((100% - 20px) / 5);">
												<div>{{item}}</div>
											</div>
										</div>
									</div>
									<el-button type="primary"
										style=" background-color: #006E4B; border: 1px solid #006E4B;margin: 30px 0 0 40%;"
										@click="savefileUrl()">确 定</el-button>
								</el-dialog>
								<el-col :span="3">
									<download-excel class="export-excel-wrapper" :fields="download_excel" name="工资占比表"
										:fetch="ExportForm" style="">
										<el-button
											style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
											导出</el-button>
									</download-excel>
								</el-col>
							</el-row>

							<el-row style="margin: 0px 2%; margin-top: 10px;">
								<el-row style="margin-top: 10px;">
									<el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }"
										:border="true" ref="table" :data="tabledatas" height="570" tooltip-effect="dark"
										style="width: 100%;" @selection-change="handleSelectionChange"
										@select-all="handleSelectAll" @expand-change="handleSelect"
										:row-class-name="tableRowClassName" :expand-row-keys="expands">
										<el-table-column type="expand" fixed>
											<template slot-scope="scope">
												<el-table
													:header-cell-style="{ background: '#edeff1', color: '#000000' }"
													:border="true" ref="table" :data="childTable" height="400"
													tooltip-effect="dark" style="width: 100%;"
													@selection-change="handleSelectionChanges" @select="handleSelects">
													<!-- <el-table-column type="selection" align="center" width="55">
													</el-table-column> -->
													<el-table-column align="center" label="序号" width="50">
														<template
															slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
													</el-table-column>
													<el-table-column prop="organize_name" align="center" label="支援项目名">
													</el-table-column>
													<el-table-column prop="number_of_investors" align="center"
														label="开资人数"></el-table-column>
													<el-table-column prop="payroll_payable" align="center"
														label="工资表应发工资"></el-table-column>
													<el-table-column prop="payroll_actual_salary" align="center"
														label="工资表实发工资"></el-table-column>
												</el-table>
											</template>
										</el-table-column>

										<!-- <el-table-column type="selection" width="55">
										</el-table-column> -->
										<el-table-column align="center" label="序号" width="55" fixed>
											<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
										</el-table-column>
										<el-table-column prop="organize_name" align="center" label="项目名称" width="200" fixed>
										</el-table-column>
										<el-table-column align="center" label="收入">
											
											<el-table-column prop="actual_estimate_name" align="center" label="是否开票"
												width="120">
												<template slot-scope="scope">
													<el-select v-show="scope.row.show"
														style="margin-right:10px"
														v-model="scope.row.actual_estimate" clearable
														size="mini">
														<el-option v-for="item in lqList"
															:value="item.value" :key="item.value"
															:label="item.label">
														</el-option>
													</el-select>
													<span
														v-show="!scope.row.show">{{scope.row.actual_estimate_name}}</span>
												</template>
											
											</el-table-column>

											<el-table-column align="center" label="开发票金额" width="120">
												<template slot-scope="scope">
													<el-input v-show="scope.row.show"
														v-model="scope.row.invoiced_amount" size="mini"
														style="margin-left:-5px; width: 70px;"></el-input>
													<span v-show="!scope.row.show">{{ scope.row.invoiced_amount}}</span>
												</template>
											</el-table-column>

											<el-table-column align="center" label="开票明细" width="100">
												<el-table-column prop="wage_quota" align="center" label="工资定额"
													width="100">
													<template slot-scope="scope">
														<el-input v-show="scope.row.show" v-model="scope.row.wage_quota"
															size="mini" style="margin-left:-5px; width: 70px;">
														</el-input>
														<span v-show="!scope.row.show">{{ scope.row.wage_quota }}</span>
													</template>
												</el-table-column>
												<el-table-column prop="contract_amount" align="center" label="合同金额"
													width="100">
													<template slot-scope="scope">
														<el-input v-show="scope.row.show"
															v-model="scope.row.contract_amount" size="mini"
															style="margin-left:-5px; width: 70px;"></el-input>
														<span v-show="!scope.row.show">{{ scope.row.contract_amount
                                                        }}</span>
													</template>
												</el-table-column>
												<el-table-column prop="quota_proportion" align="center" label="定额占比"
													width="100">
													<template slot-scope="scope">
														<span>{{ scope.row.quota_proportion }}%</span>
													</template>
												</el-table-column>
											</el-table-column>
										</el-table-column>
										<el-table-column align="center" label="工资明细">
											<el-table-column prop="invoicing_shift" align="center" label="开发票班次"
												width="120">
												<template slot-scope="scope">
													<el-input v-show="scope.row.show"
														v-model="scope.row.invoicing_shift" size="mini"
														style="margin-left:-5px; width: 70px;"></el-input>
													<span v-show="!scope.row.show">{{ scope.row.invoicing_shift
													}}</span>
												</template>
											</el-table-column>
											<el-table-column prop="quota_difference" align="center" label="定额差额" width="120"></el-table-column>
											<el-table-column prop="number_of_investors" align="center" label="开资人数" width="80"></el-table-column>
											<el-table-column prop="substitute" align="center" label="替班" width="120"></el-table-column>
											<el-table-column prop="substitute_salary" align="center" label="代岗工资" width="120"></el-table-column>
											<el-table-column prop="payroll_payable" align="center" label="工资表应发工资" width="120"></el-table-column>
											<el-table-column prop="personal_part_of_social_security" align="center" label="社保个人部分" width="120"></el-table-column>
											<el-table-column prop="accumulation_fund_deduction" align="center" label="公积金扣款" width="120"></el-table-column>
											<el-table-column prop="accident_insurance_deduction" align="center" label="意外保险扣款" width="120"></el-table-column>
											<el-table-column prop="clothing_deposit" align="center" label="服装押金" width="100"></el-table-column>
											<el-table-column prop="payroll_actual_salary" align="center" label="工资表实发工资" width="120"></el-table-column>

											<el-table-column prop="temporary_expenses" align="center" label="临勤费用"
												width="120">
												<template slot-scope="scope">
													<el-input v-show="scope.row.show"
														v-model="scope.row.temporary_expenses" size="mini"
														style="margin-left:-5px; width: 70px;"></el-input>
													<span v-show="!scope.row.show">{{ scope.row.temporary_expenses
													}}</span>
												</template>
											</el-table-column>
											<el-table-column prop="total_expenses" align="center" label="总费用"
												width="120"></el-table-column>
											
											<el-table-column prop="actual_delivery_shift" align="center" label="实发班次"
												width="120">
												<template slot-scope="scope">
													<el-input v-show="scope.row.show"
														v-model="scope.row.actual_delivery_shift" size="mini"
														style="margin-left:-5px; width: 70px;"></el-input>
													<span v-show="!scope.row.show">{{ scope.row.actual_delivery_shift
													}}</span>
												</template>
											</el-table-column>


										</el-table-column>
										<el-table-column align="center" label="工资占比">
											<el-table-column prop="proportion_wages" align="center" label="本月工资占比" width="80">
												<template slot-scope="scope">
													<span>{{ scope.row.proportion_wages }}%</span>
												</template>
											</el-table-column>
											<el-table-column prop="previous_month_one" align="center" label="上月工资占比" width="80">
												<template slot-scope="scope">
													<span>{{ scope.row.previous_month_one }}%</span>
												</template>
											</el-table-column>
										</el-table-column>
										<el-table-column align="center" label="备注" width="160">
											<template slot-scope="scope">
												<el-input v-show="scope.row.show" v-model="scope.row.remarks"
													size="mini" style="margin-left:-5px; width: 150px;"></el-input>
												<span v-show="!scope.row.show">{{ scope.row.remarks }}</span>
											</template>
										</el-table-column>
										<el-table-column align="center" label="状态" width="160">
											<template slot-scope="scope">
												<img src="../../../assets/待审批.png" v-show="scope.row.spare5 === '0'" />
												<img src="../../../assets/已同意.png" v-show="scope.row.spare5 === '1'" />
											</template>
										</el-table-column>
										<el-table-column align="center" label="操作" width="150" fixed="right">
											<template slot-scope="scope">
												<button
													style="width: 50px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;border-radius: 5px"
													@click="edit(scope.$index, scope.row)">编辑</button>
												<button
													style="width: 50px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;border-radius: 5px"
													@click="save(scope.$index, scope.row)">保存</button>
												<!-- <img src="../../../assets/编辑.png" @click="Edit(scope.row)" /> -->
											</template>
										</el-table-column>
									</el-table>
								</el-row>

								<el-row style="margin: 0px 2%; margin-top: 10px; font-weight: 600;">
									<el-col :span="4">
										<span>总经理审批：</span>
									</el-col>
									<el-col :span="4">
										<span>集团行政人资总监：</span>
									</el-col>
									<el-col :span="4">
										<span>城市公司总经理审批：</span>
									</el-col>
									<el-col :span="4">
										<span>行政经理：</span>
									</el-col>
									<el-col :span="4">
										<span>制表：</span>
									</el-col>
								</el-row>
							</el-row>
						</el-col>

					</el-row>



				</div>
			</el-row>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	// import Structure from "../../utils/structure/structure.vue";

	export default {
		components: {
			// Structure: Structure,
		},
		data() {
			return {
				tabledatas: [],
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],
				ids: [],
				childTable: [],
				fileData: [],
				dialogVisibledr: false,
				fileDatatitle: false,
				//条件
				condition: {
					years_date: this.$globals.getNowTimes(),
					project_id: "",
				},
				// 领取方式
				lqList: [{
					value: "0",
					label: '实开'
				}, {
					value: "1",
					label: '预估'
				}],

				//详情
				ruleForm: {
					id: '',
					invoiced_amount: '',
					wage_quota: '',
					contract_amount: '',
					number_of_investors: '',
					payroll_payable: '',
					personal_part_of_social_security: '',
					accident_insurance_deduction: '',
					clothing_deposit: '',
					payroll_actual_salary: '',
				},
				
				download_excel: {
					"组织架构名称":"framework_name",
					"项目名称": "organize_name",
					"是否开票": "actual_estimate_name",
					"开发票金额": "invoiced_amount",
					"工资定额": "wage_quota",
					"合同金额": "contract_amount",
					"定额占比": "quota_proportion",
					"开发票班次": "invoicing_shift",
					"定额差额": "quota_difference",
					"开资人数": "number_of_investors",
					"替班": "substitute",
					"代岗工资": "substitute_salary",
					"工资表应发工资": "payroll_payable",
					"社保个人部分": "personal_part_of_social_security",
					"公积金扣款": "accumulation_fund_deduction",
					"意外保险扣款": "accident_insurance_deduction",
					"服装押金": "clothing_deposit",
					"工资表实发工资": "payroll_actual_salary",
					"临勤费用": "temporary_expenses",
					"总费用": "total_expenses",
					"实发班次": "actual_delivery_shift",
					"本月工资占比": "proportion_wages",
					"上月工资占比": "previous_month_one",
					"备注": "remarks",
				},
				json_meta: [
					[{
						" key ": " charset ",
						" value ": " utf- 8 "
					}]
				]
			};
		},
		methods: {
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				});
			},
			//子表没数据不展示折叠箭头
			// tableRowClassName(childTable) {
			// 	if (row.length == 0) {
			// 		return 'row-expand-cover';
			// 	} else {
			// 		return '';
			// 	}
			// },
			openfileUrl() {
				this.dialogVisibledr = true;
				this.fileurl = "";
				this.fileDatatitle = false;
				this.fileData = [];
			},
			closeDialog() {
				this.$refs.adModel.clearFiles()
			},
			handleAvatarSuccess(res, file) {
				this.fileurl = res.data.fileUrl;
			},
			handleSelect(row, expandedRows) {
				axios.get(this.$globals.http + 'Regional/getSupportProportionTable', {
					params: {
						info: row.id
					}
				}).then(res => {
					this.childTable = res.data.data;
				}).catch(err => {
					console.log(err)
				})
			},
			//点击编辑
			edit(index, row) {
				row.show = true;
				this.$set(this.$refs.table.tableData, index, row);
			},
			//点击保存
			save(index, row) {
				var url = 'Regional/updateRegional';
				var record = {
					id: row.id,
					wage_quota: row.wage_quota,
					contract_amount: row.contract_amount,
					invoiced_amount: row.invoiced_amount,
					remarks: row.remarks,
					
					payroll_payable: row.payroll_payable,
					temporary_expenses: row.temporary_expenses,
					invoicing_shift: row.invoicing_shift,
					actual_delivery_shift: row.actual_delivery_shift,
					actual_estimate: row.actual_estimate,
				};
				var data = this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					this.$message.success('修改成功！');
					row.show = false;
					this.$set(this.$refs.table.tableData, index, row);
				}

			},
			//查询
			Find() {
				const url = this.$globals.http + "Regional/ProportionTableKeyAll";
				axios.post(url, {
					page_num: this.page_num,
					page_size: this.page_size,
					years_date: this.condition.years_date + '-01',
					applicant_id: this.$globals.user.staff_id,
					// organize_id: this.condition.project_id,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;
					if (code === '200') {
						this.tableData = data;
						this.total = data.total;
						this.tableData.forEach(element => {
							element["show"] = false
						});
						this.tabledatas = this.tableData
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},

			//导表
			async ExportForm() {

				var url = 'Regional/ProportionTableKeyAll';
				var record = {
					years_date: this.condition.years_date + '-01',
					applicant_id: this.$globals.user.staff_id,
					// applicant_id:41022,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if (data.length > 0) {
							this.$message.success("导表成功！文件下载中！");
							return data;
						} else {
							this.$message.success("没有可以导出的数据！");
							return null;
						}

					}
				}
			},
			//导入
			savefileUrl() {
				const url = this.$globals.http + "file/setProportionTable";
				axios.post(url, {
					file_Route: this.fileurl,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;


					if (code === '200') {
						if (data === [] || data === '') {
							this.$message.success('导入成功！');
							this.dialogVisibledr = false;
						} else {
							this.$message.success('导入失败！');
							this.fileData = data;
							this.fileDatatitle = true;
							this.fileurl = '';
							// console.log(this.fileData)
						}

					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			//审批
			async examine(e) {
				var ids;
				if (e === null || e === "" || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning("请先选择操作数据！");
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}

				var url = "Regional/Examine";
				var record = {
					ids: ids,
					years_date: this.condition.years_date + '-01',
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.trash();
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val
				this.Find();
			},
		},
		async created() {
			this.tabledatas = this.tableData
			this.Find();

		}
	}
</script>

<style scoped="scoped">
	>>>.el-table__fixed-footer-wrapper {
		display: initial;
	}

	>>>.el-button:hover {
		background-color: #FFFFFF;
	}

	>>>.el-button:focus {
		background-color: #FFFFFF;
	}

	>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006E4B;
	}

	>>>.el-input__inner:focus {
		border-color: #006E4B;
	}

	>>>.el-select .el-input.is-focus .el-input__inner {
		border-color: #006E4B;
	}

	>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	>>>.el-checkbox__inner:hover {
		border-color: #006E4B;
	}

	>>>.row-expand-cover .el-table__expand-column .el-icon {
		visibility: hidden;
	}
</style>



// WEBPACK FOOTER //
// GzZb.vue?35c32ec0